// ============================================================
// aluminumSKUs.js
// SKU mapping for the Aluminum fence estimator.
// Pure data only — no prices here. Prices live in the Price List
// (Firestore) and are resolved by SKU in aluminumCalc.js (built next).
// Product: residential aluminum fence — one style, 54" high, 6'-wide panels.
//
// Differences from the vinyl estimator this file mirrors:
//   - FOUR post types (line / corner / end / GATE). Vinyl has three and folds
//     its gate posts into the user-entered end-post count; aluminum keys the
//     gate post separately.
//   - NO POST CAPS. Vinyl caps every post (3 selectable styles); aluminum has
//     none, so no cap SKU is defined here — see the note below.
//   - Gate panels vary by TWO dimensions, width AND top shape, so they use a
//     nested map rather than vinyl's single width-keyed map.
// ============================================================

// --- Panels & Posts ---
export const ALUMINUM_PANEL_SKU = '54AP';        // Aluminum Fence Panel 54" H x 6' W
export const ALUMINUM_LINE_POST_SKU = '2LPAL';   // Aluminum Line Post
export const ALUMINUM_CORNER_POST_SKU = '2LPAC'; // Aluminum Corner Post
export const ALUMINUM_END_POST_SKU = '2LPAE';    // Aluminum End Post
export const ALUMINUM_GATE_POST_SKU = '2LPAGP';  // Aluminum Gate Post (distinct from the end post)

// --- Post Caps ---
// INTENTIONALLY OMITTED. Aluminum posts ship capped, so unlike vinyl (which has
// VINYL_CAP_SKU and adds 1 cap per post) there is no cap part to price and the
// calc engine must never add a cap line. This comment is the record of that
// decision — the absence is deliberate, not an oversight.

// --- Gates ---
// Gate panels are prebuilt by WIDTH ('4' or '5' feet) and TOP SHAPE
// ('flat' or 'arched') — four combinations. Nested map so the engine can read
// ALUMINUM_GATE_PANEL_SKU[width][shape]; an unknown width or shape resolves to
// undefined and surfaces as a PRODUCT NOT FOUND line, matching vinyl.
export const ALUMINUM_GATE_PANEL_SKU = {
  '4': {
    flat: 'ALUM4GATE',    // Aluminum Gate 4' W x 54" H — flat top
    arched: 'ALUM4GATEA', // Aluminum Gate 4' W x 54" H — arched top
  },
  '5': {
    flat: 'ALUM5GATE',    // Aluminum Gate 5' W x 54" H — flat top
    arched: 'ALUM5GATEA', // Aluminum Gate 5' W x 54" H — arched top
  },
};

// --- Gate Hardware ---
// Per gate leaf: 1 hinge set (sold as a pair).
export const ALUMINUM_GATE_HINGE_SKU = 'SCGH'; // Self-Closing Gate Hinges (pair)

// Latch: one type chosen for the whole job (default = standard gravity).
// Single gate = 1 latch. Double pair = 1 latch (shared).
// `topPull` is the pool-code latch — the same Trident part vinyl offers.
export const ALUMINUM_LATCH_SKU = {
  standard: 'SGAG', // Standard Gravity Latch (DEFAULT)
  topPull: 'MLJR',  // Trident 10 Top Pull Latch Junior (pool code)
};

// Drop rod: 1 per double pair only.
export const ALUMINUM_DROP_ROD_SKU = 'CB2'; // Drop Rod / Cane Bolt
